import java from './images/java_logo_640.jpg';
import python from './images/Python.png';
import visual from './images/visual.png';
import sql from './images/sql.png';
import r from './images/R.jpg';
import dart from './images/dart.png';
import react from './images/react.png';
import angular from './images/angular.png';
import express from './images/express.png';
import node from './images/node.png';
import bootstrap from './images/bootstrap.png';
import flutter from './images/flutter.jpg';
import photoshop from './images/photoshop.jpg';
import fusion from './images/fusion.jpg';
import procreate from './images/procreate.png';
import osi from './images/osi.png';
import pandas from './images/pandas.png';
import knime from './images/knime.png';
import powerbi from './images/powerbi.png';




export const featuredPortfolio = [
    {
        id: 1,
        title: "Java",
        img: java,
    },
    {
        id: 2,
        title: "Python",
        img: python,
    },
    {
        id: 3,
        title: "Visual Basic",
        img: visual,
    },
    {
        id: 4,
        title: "SQL",
        img: sql,
    },
    {
        id: 5,
        title: "R",
        img: r,
    },
    {
        id: 6,
        title: "Dart",
        img: dart,
    },
];

export const webPortfolio = [
    {
        id: 1,
        title: "React",
        img: react,
    },
    {
        id: 2,
        title: "Angular",
        img: angular,
    },
    {
        id: 3,
        title: "Node",
        img: node,
    },
    {
        id: 4,
        title: "Bootstrap",
        img: bootstrap,
    },
    {
        id: 5,
        title: "Express",
        img: express,
    },

];


export const mobilePortfolio =  [
    {
        id: 1,
        title: "Flutter",
        img: flutter,
    },

];

export const designPortfolio = [

    {
        id: 1,
        title: "Adobe Photoshop",
        img: photoshop,
    },
    {
        id: 2,
        title: "CAD Fusion 360",
        img: fusion,
    },
    {
        id: 3,
        title: "Procreate",
        img: procreate,
    },

];

export const dataPortfolio = [
    {
        id: 1,
        title: "Power BI",
        img: powerbi,
    },
    {
        id: 2,
        title: "OSI Soft",
        img: osi,
    },
    {
        id: 3,
        title: "Knime",
        img: knime,
    },
    {
        id: 4,
        title: "Pandas",
        img: pandas,
    },
];